<script lang="ts">
    import KpCollapsibleButtonMenu from '../collapsible-button-menu/KpCollapsibleButtonMenu.svelte';
    import {afterUpdate} from 'svelte';

    let buttonPanel: Element | undefined;
    let buttonPanelVisible = false;

    afterUpdate(() => {
        const listOfButtons = buttonPanel?.querySelectorAll<HTMLElement>('button, a.btn');
        buttonPanelVisible = Array.from(listOfButtons ?? []).some((button) => isVisible(button));
    })

    function isVisible(element: HTMLElement) {
        return !!(element.offsetWidth || element.offsetHeight);
    }
</script>

<div class="menu-wrapper">
    <div class="menu-wrapper-main">
        <slot name="main"></slot>
    </div>
    {#if $$slots.menu}
        <div class="menu-wrapper-menu buttonsPanel" class:button-panel-visible={buttonPanelVisible} class:button-panel-not-visible={!buttonPanelVisible}>
            <KpCollapsibleButtonMenu let:collapsed let:state>
                <div bind:this={buttonPanel}>
                    <slot name="menu" {collapsed} {state}></slot>
                </div>
            </KpCollapsibleButtonMenu>
        </div>
    {/if}
</div>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";
    @import (reference) "src/shared/ui-widgets/collapsible-button-menu/collapsible-menu.constants.less";

    .button-panel-not-visible {
        visibility: hidden;
    }

    .button-panel-visible {
        visibility: visible;
    }

    .menu-wrapper {
        display: grid;
        grid-template-columns: auto @collapsed-width;
    }

    .menu-wrapper-menu {
        grid-column: 2 / span 1;
        grid-row: 1;
        position: relative;
        justify-self: end;
    }

    .menu-wrapper-main {
        grid-column: 1 / span 1;
        grid-row: 1;
        width: 100%;
        padding: 0.5em;
    }
</style>